import React, { FC, useEffect, useState } from 'react'
import Modal from '../common/Modal'

interface ModalState {
  id: number
  name: string
  cost: number | null
}

interface Props {
  modalState: ModalState
  closeCallback: VoidFunction
  modCallback: (id: number, cost: number | null) => void
  isDisplay: boolean
}

const CostModal: FC<Props> = (props) => {
  const {
    modalState,
    closeCallback,
    modCallback,
    isDisplay,
  } = props

  const [cost, setCost] = useState<string | null>(null)

  const changeCost = (value: string) => {
    setCost(value)
  }

  const formatCost = () => {
    const tmpVal = cost !== null ? cost.replace(/[０-９]/g, (s) => String.fromCharCode(s.charCodeAt(0) - 0xFEE0)).replace(/[^0-9]/g, '') : null
    setCost(tmpVal)
  }

  const resetParam = () => {
    setCost(null)
  }

  const closeModal = () => {
    closeCallback()
    resetParam()
  }

  const submitCost = () => {
    modCallback(modalState.id, Number(cost))
    setTimeout(() => {
      resetParam()
    }, 1000)
  }

  useEffect(() => {
    setCost(modalState.cost?.toString() || null)
  }, [isDisplay])

  return (
    <Modal
      title="コスト編集"
      show={isDisplay}
      wrapperClass="effort_add_label_group"
      closeCallback={closeModal}
      closeable
    >
      <>
        <div
          style={{
            marginBottom: "24px",
            fontSize: "16px",
            fontWeight: "bold",
          }}
        >
          {`${modalState.name}さんの1時間あたりのコスト`}
        </div>
        <div className="item">
          <div className="title">
            1時間あたりのコスト(円)
          </div>
          <div className="detail equal_space row_1">
            <input
              type="text"
              value={cost || ""}
              onChange={(e) => changeCost(e.target.value)}
              onBlur={() => formatCost()}
              placeholder="設定されていません"
            />
          </div>
        </div>
      </>
      <>
        <button
          type="button"
          className="button cancel"
          onClick={closeModal}
        >
          キャンセル
        </button>
        <button
          type="button"
          className="button"
          onClick={submitCost}
          disabled={modalState.cost === Number(cost)}
        >
          更新
        </button>
      </>
    </Modal>
  )
}

export default CostModal
